import { create } from 'zustand';

interface OnboardingBannerState {
  dismissed: boolean;
  dismiss: () => void;
}

/**
 * Per-session dismissal for the onboarding resume banner (#67). Deliberately
 * NOT persisted — a dismiss lasts the session, and the nudge returns on the
 * next launch until onboarding is actually completed. Shared across both
 * dashboards so dismissing on one hides it on the other.
 */
export const useOnboardingBannerStore = create<OnboardingBannerState>((set) => ({
  dismissed: false,
  dismiss: () => set({ dismissed: true }),
}));
